import React, { useState } from 'react';
import api from '../api';
import { useNavigate } from 'react-router-dom';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await api.post('/auth/register', { name, email, password });
      localStorage.setItem('token', res.data.token);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed');
    }
  };

  return (
    <div className="d-flex flex-column flex-md-row vh-100">
      {/* Left Image Panel */}
      <div className="d-none d-md-block col-md-6 p-0">
        <img
          src="/assets/login-image.png"
          alt="Register Visual"
          className="img-fluid h-100 w-100"
          style={{ objectFit: 'cover', borderTopRightRadius: '2rem', borderBottomRightRadius: '2rem' }}
        />
      </div>

      {/* Right Register Form */}
      <div className="col-12 col-md-6 d-flex align-items-center justify-content-center p-4">
        <div className="w-100" style={{ maxWidth: '400px' }}>
          <div className="text-center mb-4">
            <img src="/assets/macroai-logo.png" alt="Macro.ai" style={{ height: '100px' }} />
          </div>
          <h3 className="text-center mb-3">Sign Up for MacroTrackAI</h3>
          <form onSubmit={handleRegister}>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">Name</label>
              <input
                id="name"
                type="text"
                className="form-control"
                placeholder="Enter name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                id="email"
                type="email"
                className="form-control"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">Password</label>
              <input
                id="password"
                type="password"
                className="form-control"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {error && <div className="alert alert-danger py-2">{error}</div>}
            <button type="submit" className="btn btn-success w-100 mb-3">Sign Up</button>
            <div className="text-center">
              <span className="small">Already have an account? <a href="/login">Login</a></span>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
